var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPuzzleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2050 2050",
    id: "Puzzle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f89f1b",
    d: "M1084.6 461.6a146 146 0 0 1-92.4 184.6 144.5 144.5 0 0 1-28.5 6.4l61.9 185.7-198.9 66.2a143.8 143.8 0 0 0-5.6-69.7C795.7 758.3 713 717 636.5 742.4a146.1 146.1 0 0 0-55 243.8l-198.8 66.2-167.9-504.1a146.2 146.2 0 0 1 92.6-185l504.1-167.9 61.8 185.7a146.3 146.3 0 0 1 211.3 80.5Z",
    className: "colorf8881b svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8aa3e",
    d: "M1084.6 461.6a146 146 0 0 0-86.7-90.4 146.1 146.1 0 0 1-53.6 245.2 143.5 143.5 0 0 1-28.4 6.4l61.8 185.7-150.8 50.2a143.5 143.5 0 0 1-.2 45.8l198.9-66.2-61.9-185.7a144.5 144.5 0 0 0 28.5-6.4 146 146 0 0 0 92.4-184.6Z",
    className: "colorf89a3e svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a86604",
    d: "M303.5 604.1a146.2 146.2 0 0 1 92.6-185l441-146.9-25.6-76.8-504.1 167.9a146.2 146.2 0 0 0-92.6 185l167.9 504.1 63-21Z",
    className: "colorf08013 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebb467",
    d: "M1842.7 1177h-205.8a146 146 0 1 1-278.9 60.3 144.7 144.7 0 0 1 13-60.3h-205.9V981.3a146 146 0 1 0 0-286.2V499.4h531.3a146.3 146.3 0 0 1 146.3 146.3Z",
    className: "color67baeb svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8ae46",
    d: "M1215.3 1012.8a186.5 186.5 0 0 0 36.1 3.6A181.6 181.6 0 0 0 1433 834.8c0-100.3-81.3-181.5-181.6-181.5a186.5 186.5 0 0 0-36.1 3.5V499.4h-50.2v195.7a145.9 145.9 0 1 1 0 286.2V1177h50.2Z",
    className: "color46a1f8 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a83f",
    d: "M958.6 1515.8a146 146 0 0 0 145.9 146 144.3 144.3 0 0 0 60.6-13.2v206H633.8a146.3 146.3 0 0 1-146.3-146.3V1177h209.6a146 146 0 1 1 258.4 0h209.6v206a144.3 144.3 0 0 0-60.6-13.2 146 146 0 0 0-145.9 146Z",
    className: "colorf4c23f svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbf66",
    d: "M955.5 1177a146 146 0 0 0-257.7-137.3 146.1 146.1 0 0 1 206.3 192h209.5v138.4a143.1 143.1 0 0 1 51.5 12.9v-206Z",
    className: "colorfad564 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4a83f",
    d: "M704.5 1789.4a146.3 146.3 0 0 1-146.3-146.3V1177h-70.7v531.3a146.3 146.3 0 0 0 146.3 146.3h531.3v-65.2Z",
    className: "colorf4a93f svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#de9426",
    d: "M1842.7 1177v531.3a146.3 146.3 0 0 1-146.3 146.3h-531.3v-206a144.3 144.3 0 0 1-60.6 13.2 146 146 0 0 1 0-292 144.3 144.3 0 0 1 60.6 13.2v-206H1371a146 146 0 1 0 278.9 60.3 146.3 146.3 0 0 0-13-60.3Z",
    className: "colorde3226 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1741a",
    d: "M1529.3 1381.1a150.9 150.9 0 0 0 25.4 2.2 146.1 146.1 0 0 0 132.9-206.3h-50.7a146.3 146.3 0 0 1 13 60.3c0 71.9-52.1 131.7-120.6 143.8zm-313.4 1.9v-206h-50.8v193.2a144.6 144.6 0 0 1 50.8 12.8zm-206.6 132.8a146 146 0 0 1 120.6-143.8 151.8 151.8 0 0 0-25.4-2.2 146 146 0 0 0 0 292 151.8 151.8 0 0 0 25.4-2.2c-68.5-12.1-120.6-71.9-120.6-143.8zm155.8 145.6v193.2h50.8v-206a144.6 144.6 0 0 1-50.8 12.8z",
    className: "colorb11a31 svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111.8,
    height: 329.42,
    x: 1730.9,
    y: 723,
    fill: "#fbc983",
    rx: 55.9,
    ry: 55.9,
    className: "color83d0fb svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 111.8,
    height: 277.54,
    x: 1730.9,
    y: 1438.9,
    fill: "#f4a633",
    rx: 55.9,
    ry: 55.9,
    className: "colorf44533 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleIcon);
export default __webpack_public_path__ + "static/media/puzzleIcon.69432acd3c66f51533056d893fe2b51a.svg";
export { ForwardRef as ReactComponent };